import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AchooInputComponent} from '../achoo-input/achoo-input.component';
import {IonRangeSliderComponent} from 'ng2-ion-range-slider/lib/ion-range-slider.component';
import {CommonConstant} from '../../app.constants';
import {ValidationHandlerService} from '../validation-handler.service';

@Component({
  selector: 'achoo-slider',
  templateUrl: './achoo-slider.component.html',
  styleUrls: ['./achoo-slider.component.scss']
})
export class AchooSliderComponent extends AchooInputComponent<any> implements OnInit, OnDestroy {
  @Input()
  public min: number;
  @Input()
  public max: number;
  @Input()
  public from: number;
  @Input()
  public to: number;
  @Input()
  public dataType = 'number';
  @Input()
  public overMaxValue = false;

  public maxValue;
  public minValue;

  @ViewChild('sliderElement')
  sliderElement: IonRangeSliderComponent;

  constructor(protected validationHandlerService: ValidationHandlerService) {
    super(validationHandlerService);
  }

  ngOnInit() {
    this.minValue = this.from;
    this.maxValue = this.to;
  }

  ngOnDestroy() {
    if (this.sliderElement) {
      this.sliderElement.destroy();
    }
  }

  onChange(e) {
    this.minValue = e.from;
    this.maxValue = e.to;
    this.onModelChange({from: e.from, to: e.to});
    if (this.maxValue < this.max) {
      this.overMaxValue = false;
    } else {
      this.overMaxValue = true;
    }
  }

  isNumber() {
    return this.dataType === CommonConstant.NUMBER_DATA_TYPE;
  }

  isPercent() {
    return this.dataType === CommonConstant.PERCENT_DATA_TYPE;
  }

  resetSlider() {
    this.minValue = this.min;
    this.maxValue = this.max;
  }

  updateRangeValue(min, max) {
    if (min) {
      this.from = min;
      this.minValue = min;
    }

    if (max) {
      this.to = max;
      this.maxValue = max;
    }
  }

  isMaximumValue(endValue) {
    return endValue && endValue === this.max;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-slider/achoo-slider.component.ts